import { AOV_DEFAULT_VALUE, BASE_FEE, DEFAULT_ENGAGEMENT_RATE, DIE_HARD_FANS_DEFAULT_VALUE, ENGAGEMENT_RATE_MULTIPLIER, FEE_PER_THOUSAND_VIEWS, FOLLOWER_FEE_MULTIPLIER, MAX_FEE, } from '../../constants/fairFee.js';
export const fairFeeCalculation = ({ followers, dieHardFans = DIE_HARD_FANS_DEFAULT_VALUE, engagementRate = DEFAULT_ENGAGEMENT_RATE, aovFactor = AOV_DEFAULT_VALUE, avgComments, avgLikes, avgViews, }) => {
    let fairFee = null;
    if (!followers || followers < 0)
        return null;
    if (!aovFactor || aovFactor <= 0) {
        aovFactor = AOV_DEFAULT_VALUE;
    }
    if (!dieHardFans || dieHardFans < 0) {
        dieHardFans = DIE_HARD_FANS_DEFAULT_VALUE;
    }
    if (!engagementRate || engagementRate <= 0) {
        engagementRate = DEFAULT_ENGAGEMENT_RATE;
    }
    engagementRate = engagementRate / 100;
    if (followers < 3000) {
        return BASE_FEE;
    }
    avgLikes = Number.isFinite(avgLikes) ? avgLikes : null;
    if (!avgComments && avgLikes) {
        avgComments = calculateAvgCommentsBasedOnLikes({
            avgLikes,
            engagementRate,
        });
    }
    avgComments = Number.isFinite(avgComments) ? avgComments : null;
    if (!avgViews && avgLikes && avgComments) {
        avgViews = calculateAvgViewsBasedOnLikesComments({
            avgLikes,
            avgComments,
            engagementRate,
        });
    }
    avgViews = Number.isFinite(avgViews) ? avgViews : null;
    if (avgViews) {
        const viewBasedFee = (avgViews / 1000) * FEE_PER_THOUSAND_VIEWS + 20 * dieHardFans;
        const followerEngagementBasedFee = followers * FOLLOWER_FEE_MULTIPLIER + engagementRate * ENGAGEMENT_RATE_MULTIPLIER;
        fairFee = (0.5 * viewBasedFee) + (0.5 * followerEngagementBasedFee);
        if (followers < 100_000) {
            fairFee *= 1;
        }
        else if (followers >= 100_000 && followers < 200_000) {
            fairFee *= 0.8;
        }
        else if (followers >= 200_000 && followers < 300_000) {
            fairFee *= 0.6;
        }
        else if (followers >= 300_000 && followers < 500_000) {
            fairFee *= 0.45;
        }
        else if (followers >= 500_000) {
            fairFee *= 0.3;
        }
    }
    else {
        fairFee = followers * FOLLOWER_FEE_MULTIPLIER + engagementRate * ENGAGEMENT_RATE_MULTIPLIER;
    }
    if (fairFee <= 0) {
        return BASE_FEE;
    }
    fairFee = adjustFeeBasedOnAovFactor(fairFee, aovFactor);
    fairFee = applyFeeBoundaries(fairFee);
    return fairFee;
};
const adjustFeeBasedOnAovFactor = (fee, aovFactor) => {
    return fee * aovFactor;
};
const applyFeeBoundaries = (fee) => {
    if (fee === 0 || !fee) {
        return null;
    }
    if (fee > MAX_FEE) {
        return MAX_FEE;
    }
    if (fee < BASE_FEE) {
        return BASE_FEE;
    }
    if (fee < 1000) {
        return Math.round(fee);
    }
    return parseFloat(fee.toFixed(2));
};
export const calculateAvgViewsBasedOnLikesComments = ({ avgLikes, avgComments, engagementRate, }) => {
    if (!engagementRate) {
        engagementRate = 0.035;
    }
    if (avgLikes && avgComments) {
        return (avgLikes + avgComments) / engagementRate;
    }
    return null;
};
export const calculateAvgCommentsBasedOnLikes = ({ avgLikes, engagementRate, }) => {
    return avgLikes * engagementRate;
};
export const formatFairFee = (fee, currency = '$') => {
    if (fee === 0 || !fee) {
        return 'N/A';
    }
    return `${currency}${fee}`;
};
